<!--
 * @LastEditors: chuhongguang
 * @desc: 自定义公式
 * @场景: 重构公式 抽屉中
-->
<template>
    <div class="reconstruction-card">
      <el-card>
        <div class="flex_wrap">
          <div v-for="(x, indexGroup) in functionGroupList" :key="indexGroup">
            <div class="reconstruction-box-out-1">
              <div class="reconstruction-triangle-1" style="width: 95px;height: 15px;">
                <div class="reconstruction-triangle-out">
                  <el-tooltip placement="top" :open-delay="500" effect="light">
                    <div slot="content">
                      <span>{{ content[x.title] }}</span>
                    </div>
                    <span class="cursor">?</span>
                  </el-tooltip>
                </div>
              </div>
              <img style="margin-top: -5px;" width="18" height="18" :src="require('../../assets/functionFonts/' + x.title + '.svg')"/>
              <div>
                <el-dropdown trigger="click" @command="addFactorItem">
                  <span class="el-dropdown-link">
                    {{x.title}}<i style="color: #A0A0A0;" class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown" :class="{'h_400' : x.support_functions.length > 10}">
                    <el-scrollbar style="height: 100%;">
                      <el-dropdown-item v-for="(y, item) in x.support_functions" :key="item" :command="y" class="flex">
                        <span style="flex: 10;">{{y.title_chinese}}</span>
                        <span style="flex: 1;" class="align_right">
                          <el-tooltip placement="right" :open-delay="1000" effect="light">
                            <div slot="content">
                              <span>
                                “{{y.format}}”<br/>
                                说明：{{y.instruction}}
                              </span>
                            </div>
                            <img width="16" height="16" src="../../assets/问号.svg" />
                          </el-tooltip>
                        </span>
                      </el-dropdown-item>
                    </el-scrollbar>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
</template>
<script>
// import clip from '@/utils/clipboard'
export default {
  components: {
  },
  props: ['functionGroupList'],
  data () {
    return {
      content: {
        '数据归一': '将数据映射为-1到1，或者0到1区间上，这样数据可以作为持仓权重，并结合资产回报率矩阵，测试数据对资产的预测能力',
        '引用数据': '引用资产回报率等数据',
        '基础运算': '计算滚动最大值，滚动最小值，滚动平均值等',
        '累加运算': '一般以“累加(权重*回报率)”的形式使用，可生成回测曲线用于评估数据预测能力',
        '数值变化': '将基础数据的某一部分进行转化，生成预测信号。常用于提取首次变化，提取尾部信息，降低噪音等操作',
        '金融经济': '提供如环比等有经济意义的数据转换函数',
        '数据变形': '将数据进行平移，换维度(1维到2维)等操作，可将择时因子转化为筛选因子，进而在回测页面中进行测试',
        '二维运算': '包括按天求和，按天归一等基于某一天所有相关资产的汇总信息进行处理的函数。输入只能是二维数据'
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    addFactorItem (x) {
      this.$emit('addFactorItem', x)
    }
  },
  watch: {
  },
  activated () {
  }
}
</script>

<style scoped>

.reconstruction-card >>> .el-card {
  border-radius: 0 0 10px 10px !important;
}

.reconstruction >>> .el-input-group__append,
.reconstruction >>> .el-dialog {
  border-radius: 10px;
}

.reconstruction >>> .el-dropdown-link {
  cursor: pointer;
  color: #444444;
}

.reconstruction-box-out-1 {
  position: relative;
  border: 0.5px solid #DCDCDC;
  border-radius: 7px;
  background-color: #F8F8F8;
  width: 95px;
  height: 55px;
  text-align: center;
  margin-right: 10px;
  margin-bottom: 10px;
}

.reconstruction-triangle-1 {
  background: linear-gradient(41deg, transparent 92px, #D8D8D8 0%);
  background-size: 95px 55px;
  border-top-right-radius: 4px;
}

.reconstruction-triangle-out {
  color: #FFF;
  height: 20px;
  text-align: right;
  font-size: 10px;
}

.reconstruction-strip {
  background-color: rgba(247, 247, 247, 1);
  height: 5px;
}

.reconstruction-border {
  padding: 15px 0;
  border-bottom: 1px solid #F7F7F7;
}

.reconstruction-border .el-input__icon {
  width: 15px;
  line-height: 20px;
}

.reconstruction-dialog-text {
  font-size: 14px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-style: italic;
}

.el-dropdown-menu__item {
  padding: 0px 5px 5px !important;
  width: 110px;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 30px !important;
}

.el-row {
  margin-bottom: 0 !important;
}

.errorClass >>> .el-dialog__headerbtn {
  top: 10px;
}

.errorClass >>> .el-dialog__header {
  padding: 10px;
  background-color: #A30014;
  /* border-radius: 10px 10px 0 0; */
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner {
  background-color: #F7F7F7;
  border: 1px solid #F7F7F7;
  border-radius: 10px;
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner:focus {
  border-color: #F7F7F7;
}

.reconstruction-tab-top .factor-tabs >>> .el-textarea__inner:hover {
  border-color: #F7F7F7;
}

.reconstruction-tab-top .factor-tabs >>> .temporary {
  background-color: #F7F7F7;
  border-radius: 10px;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__header.is-left {
  float: left;
  margin-bottom: 0;
  margin-right: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__nav-wrap.is-left::after,
.el-tabs--left >>> .el-tabs__nav-wrap.is-right::after,
.el-tabs--right >>> .el-tabs__nav-wrap.is-left::after,
.el-tabs--right >>> .el-tabs__nav-wrap.is-right::after {
  width: 100%;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__nav-wrap::after {
  background-color: #333;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__nav-wrap.is-left {
  margin-right: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--left >>> .el-tabs__active-bar.is-left,
.el-tabs--left >>> .el-tabs__active-bar.is-right,
.el-tabs--right >>> .el-tabs__active-bar.is-left,
.el-tabs--right >>> .el-tabs__active-bar.is-right {
  width: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__nav-scroll {
  overflow: hidden;
  border: 1px solid #E4E7ED;
  background-color: #F7F7F7;
  border-radius: 10px 10px 0 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__nav {
  background-color: #f7f7f7;
  border: 0;
}

.reconstruction-tab-top .factor-tabs  >>> .el-tabs__item {
  color: #666;
  border-radius: 4px 4px 0 0;
  padding: 0 20px;
  height: 30px;
  line-height: 30px;
  border-right: 1px solid #E3E3E3;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__item:hover {
  color: #666;
  cursor: pointer;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__item.is-active {
  color: #A30014;
  background-color: rgba(163, 0, 20, 0.15);
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__item {
  border-bottom: 0;
  border-left: 0;
}

.reconstruction-tab-top .factor-tabs >>> .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #EEE;
}

.reconstruction-dialog-tab >>> .el-input__inner {
  height: 20px !important;
  line-height: 20px !important;
  padding: 0 !important;
}

.factorInputStyle >>> .el-input__inner {
  padding: 0px 0 0 5px;
}

.reconstruction >>> .el-select-dropdown__item {
  padding: 0 !important;
}

.reconstruction >>> .el-drawer__header {
  margin-bottom: 0;
}

.date-input >>> .el-input__inner {
  height: 20px !important;
  line-height: 20px !important;
  padding: 0 5px !important;
}

.date-input >>> .el-date-editor >>> .el-range-separator {
  line-height: 20px;
  padding: 0 6px 0 0;
}

.date-input >>> .el-date-editor >>> .el-range__icon {
  line-height: 18px;
}

.date-input >>> .el-date-editor >>> .el-range__close-icon {
  width: 20px;
  line-height: 18px;
}

.boxBackground {
  margin: 3px;
  background-color: #A30013;
  border-radius: 2px;
  width: 4px;
  height: 16px;
}

.boxSpan {
  font-weight: bold;
  font-size: 14px;
  margin-left: 10px;
}

.badTishi {
  height: 437px;
  line-height: 437px;
  text-align: center;
}

.italicFont {
  font-size: 14px;
  color: #a30014;
  font-style: italic;
}

.recordClass {
  background-color: #f0f9eb;
}

.cursorRed {
  color: #A4001B;
  cursor: pointer;
}

.cursor666 {
  color: #666;
  cursor: pointer;
}

.flex100 {
  width: 100%;
  flex: 1;
  display: flex;
}
.c_A30013 {
  color: #A30013;
}

.p_3 {
  padding: 3px !important;
}

.h_400 {
  height: 400px
}

.infinite-scroll {
  height: 200px;overflow: auto;
}
.infinite-scroll .scroll-item {
  width: 100%;margin: 0;
}
.infinite-scroll .scroll-item:hover {
  background-color: #f0f9eb;
}
.infinite-scroll .scroll-item--active {
  background-color:#fdf5e6;
}

.infinite-scroll .scroll-item--active:hover {
  background-color: #fdf5e6;
}
.infinite-scroll .scroll-item-complete:hover {
  color: #A30013;
  text-decoration:underline;
}
.infinite-scroll .scroll-item-yAxis{
    width: 16px;
    display: inline-block;
    text-align: center;
    border: 1px solid #409EFF;
    color: #409EFF;
    font-size: 12px;
    padding: 1px;
    border-radius: 5px;
}
.infinite-scroll .scroll-item-yAxis:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/allPage/functionGroup.vue